import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_3260_63435)",
			children: /* @__PURE__ */ _jsx("path", { d: "M21.7605 2.94229L7.95342 16.7493L2.8802 11.6761C2.63424 11.4302 2.23542 11.4302 1.9894 11.6761L0.504787 13.1607C0.258821 13.4067 0.258821 13.8055 0.504787 14.0515L7.50799 21.0547C7.75396 21.3007 8.15278 21.3007 8.39879 21.0547L24.1358 5.3177C24.3818 5.07173 24.3818 4.67292 24.1358 4.4269L22.6512 2.94229C22.4053 2.69632 22.0064 2.69632 21.7605 2.94229Z" })
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3260_63435",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
